(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cible-skin-featured-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const syncCriteriaPillsFromUrl = (wrapper) => {
    if (wrapper.dataset.criteriaSync !== 'true') return;
    const sectionId = wrapper.dataset.collectionLayout;
    if (!sectionId) return;
    const sample = wrapper.querySelector('[data-criteria-button][data-sync-facet-param]');
    if (!sample) return;
    const paramName = sample.getAttribute('data-sync-facet-param');
    if (!paramName) return;

    const current = new URL(window.location.href);
    const selected = current.searchParams.getAll(paramName);

    wrapper.querySelectorAll('[data-criteria-button][data-sync-facet-value]').forEach((btn) => {
      const v = btn.getAttribute('data-sync-facet-value');
      const active = Boolean(v && selected.includes(v));
      btn.setAttribute('data-active', active ? 'true' : 'false');
    });
  };

  const findFacetCheckbox = (sectionId, paramName, value) => {
    for (const suffix of ['-desktop', '-overflow']) {
      const form = document.getElementById(`FacetFiltersForm--${sectionId}${suffix}`);
      if (!form) continue;
      const inputs = form.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(paramName)}"]`);
      for (const input of inputs) {
        if (input instanceof HTMLInputElement && input.value === value) return input;
      }
    }
    return null;
  };

  const mirrorFacetCheckboxBothForms = (sectionId, sourceInput) => {
    if (!(sourceInput instanceof HTMLInputElement)) return;
    const name = sourceInput.name;
    const val = sourceInput.value;
    const checked = sourceInput.checked;
    for (const suffix of ['-desktop', '-overflow']) {
      const form = document.getElementById(`FacetFiltersForm--${sectionId}${suffix}`);
      if (!form) continue;
      const twin = form.querySelector(
        `input[type="checkbox"][name="${CSS.escape(name)}"][value="${CSS.escape(val)}"]`
      );
      if (twin instanceof HTMLInputElement) twin.checked = checked;
    }
  };

  const triggerFacetUpdate = (input) => {
    const facetInputs = input.closest('facet-inputs-component');
    if (facetInputs && typeof facetInputs.updateFilters === 'function') {
      facetInputs.updateFilters();
      return;
    }
    const facetsForm = input.closest('facets-form-component');
    if (facetsForm && typeof facetsForm.updateFilters === 'function') {
      facetsForm.updateFilters();
    }
  };

  const gridObservers = new WeakMap();

  const applyLocalCriteriaForWrapper = (wrapper) => {
    const grid = wrapper.querySelector('[data-criteria-grid]');
    if (!grid) return;

    const buttons = wrapper.querySelectorAll('[data-criteria-button]');
    const values = Array.from(buttons)
      .filter((item) => item.getAttribute('data-active') === 'true')
      .filter((item) => !item.getAttribute('data-sync-facet-value'))
      .map((item) => item.dataset.criteriaButtonValue)
      .filter(Boolean);

    const cards = grid.querySelectorAll('.product-grid__item');
    cards.forEach((card) => {
      if (!values.length) {
        card.hidden = false;
        return;
      }

      const criteria = (card.dataset.criteria || '').split(',').filter(Boolean);
      card.hidden = !values.some((value) => criteria.includes(value));
    });
  };

  const observeCriteriaGrid = (wrapper) => {
    const grid = wrapper.querySelector('[data-criteria-grid]');
    if (!grid) return;

    const prev = gridObservers.get(grid);
    if (prev) prev.disconnect();

    const observer = new MutationObserver(() => {
      applyLocalCriteriaForWrapper(wrapper);
    });
    observer.observe(grid, { childList: true, subtree: false });
    gridObservers.set(grid, observer);
  };

  const bindCollectionCriteriaLayouts = () => {
    document.querySelectorAll('[data-collection-layout]').forEach((wrapper) => {
      if (!wrapper.querySelector('[data-criteria-grid]')) return;
      if (!wrapper.querySelector('[data-criteria-button]')) return;

      syncCriteriaPillsFromUrl(wrapper);
      observeCriteriaGrid(wrapper);
      applyLocalCriteriaForWrapper(wrapper);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collection-layout] [data-criteria-button]');
    if (!button) return;

    const wrapper = button.closest('[data-collection-layout]');
    if (!wrapper) return;

    const sectionTop = wrapper.getBoundingClientRect().top + window.scrollY;
    const stickyOffset = Number.parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 0;

    window.scrollTo({
      top: Math.max(sectionTop - stickyOffset - 150, 0),
      behavior: 'smooth',
    });

    const sectionId = wrapper.dataset.collectionLayout;
    const syncEnabled = wrapper.dataset.criteriaSync === 'true';
    const syncParam = button.getAttribute('data-sync-facet-param');
    const syncValue = button.getAttribute('data-sync-facet-value');

    if (syncEnabled && syncParam && syncValue && sectionId) {
      const input = findFacetCheckbox(sectionId, syncParam, syncValue);
      if (input) {
        input.checked = !input.checked;
        mirrorFacetCheckboxBothForms(sectionId, input);
        triggerFacetUpdate(input);
        return;
      }
    }

    const isActive = button.getAttribute('data-active') === 'true';
    button.setAttribute('data-active', isActive ? 'false' : 'true');
    applyLocalCriteriaForWrapper(wrapper);
  });

  document.addEventListener('DOMContentLoaded', bindCollectionCriteriaLayouts, { once: true });
  document.addEventListener('shopify:section:load', bindCollectionCriteriaLayouts);

  document.addEventListener('filter:update', () => {
    queueMicrotask(() => {
      document.querySelectorAll('[data-collection-layout]').forEach((wrapper) => {
        syncCriteriaPillsFromUrl(wrapper);
        applyLocalCriteriaForWrapper(wrapper);
      });
    });
  });

  document.addEventListener('shopify:filters-morphed', () => {
    document.querySelectorAll('[data-collection-layout]').forEach((wrapper) => {
      syncCriteriaPillsFromUrl(wrapper);
      applyLocalCriteriaForWrapper(wrapper);
    });
    bindCollectionCriteriaLayouts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-see-the-difference"] && !Shopify.designMode) return;
  try {
    
let kvBound = false;

const getSection = el =>
  el?.matches?.('[data-kv-see-the-difference-section]')
    ? el
    : el?.querySelector('[data-kv-see-the-difference-section]');

function bindArrows() {
  if (kvBound) return;
  kvBound = true;

  document.addEventListener("click", e => {
    const btn = e.target.closest(".kv-see-the-Difference__nav-arrow--prev, .kv-see-the-Difference__nav-arrow--next");
    if (!btn) return;

    const section = btn.closest("[data-kv-see-the-difference-section]");
    const slider = section?.kvSliderFor;
    if (!slider) return;

    e.preventDefault();
    slider.slick(btn.classList.contains("kv-see-the-Difference__nav-arrow--prev") ? "slickPrev" : "slickNext");
  });
}

function destroy(section) {
  if (!window.jQuery) return;

  [".kv-see-the-Difference-slider-for", ".kv-see-the-Difference-slider-nav"].forEach(sel => {
    const el = window.jQuery(section.querySelector(sel));
    if (el.hasClass("slick-initialized")) el.slick("unslick");
  });

  section.kvSliderFor = null;
  section.kvSliderNav = null;
}

function init(section) {
  if (!(window.jQuery && window.jQuery.fn.slick)) return;

  const $ = window.jQuery;
  const $for = $(section.querySelector(".kv-see-the-Difference-slider-for"));
  const $nav = $(section.querySelector(".kv-see-the-Difference-slider-nav"));

  if (!$for.length || !$nav.length) return;

  destroy(section);

  const desktop = +section.dataset.kvSeeTheDifferenceNavSlides || 3;
  const mobile = +section.dataset.kvSeeTheDifferenceNavSlidesMobile || 3;

  // $nav.on("init reInit setPosition", function () {
  //   $(this).find(".slick-slide").css("width", "48px");
  // });

  $for.slick({
    slidesToShow: 1,
    arrows: false,
    adaptiveHeight: true,
    asNavFor: $nav
  });

  $nav.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: $for,
    arrows: true,
    dots: false,
    centerMode: true,
    centerPadding: "0",
    variableWidth: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 750,
      settings: {
centerMode: true,
slidesToShow: 3,
infinite: false,
      }
    }]
  });

  section.kvSliderFor = $for;
  section.kvSliderNav = $nav;
}

function initAll() {
  if (!(window.jQuery && window.jQuery.fn.slick))
    return setTimeout(initAll, 100);

  bindArrows();

  document.querySelectorAll("[data-kv-see-the-difference-section]").forEach(init);
}

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", initAll)
  : initAll();

window.addEventListener("load", initAll);

document.addEventListener("shopify:section:load", e => {
  const section = getSection(e.target);
  if (section) init(section);
});

document.addEventListener("shopify:section:unload", e => {
  const section = getSection(e.target);
  if (section) destroy(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const initCollectionCriteriaFilter = () => {
    const wrappers = document.querySelectorAll('[data-collection-layout]');
    wrappers.forEach((wrapper) => {
      const grid = wrapper.querySelector('[data-criteria-grid]');
      const buttons = wrapper.querySelectorAll('[data-criteria-button]');
      if (!grid || buttons.length === 0) return;

      const getCards = () => Array.from(grid.querySelectorAll('.product-grid__item'));

      const applyFilter = (values) => {
        getCards().forEach((card) => {
          if (!values || values.length === 0) {
            card.hidden = false;
            return;
          }

          const criteria = (card.dataset.criteria || '').split(',').filter(Boolean);
          card.hidden = !values.some((value) => criteria.includes(value));
        });

      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const isActive = button.getAttribute('data-active') === 'true';
          const value = button.dataset.criteriaButtonValue;
          const sectionTop = wrapper.getBoundingClientRect().top + window.scrollY;
          const stickyOffset = Number.parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
          ) || 0;

          window.scrollTo({
            top: Math.max(sectionTop - stickyOffset - 150, 0),
            behavior: 'smooth',
          });

          button.setAttribute('data-active', isActive ? 'false' : 'true');
          const activeValues = Array.from(buttons)
            .filter((item) => item.getAttribute('data-active') === 'true')
            .map((item) => item.dataset.criteriaButtonValue)
            .filter(Boolean);
          applyFilter(activeValues);
        });
      });

      const observer = new MutationObserver(() => {
        const activeValues = Array.from(buttons)
          .filter((item) => item.getAttribute('data-active') === 'true')
          .map((item) => item.dataset.criteriaButtonValue)
          .filter(Boolean);
        applyFilter(activeValues);
      });

      observer.observe(grid, { childList: true, subtree: false });
      applyFilter([]);
    });
  };

  document.addEventListener('DOMContentLoaded', initCollectionCriteriaFilter, { once: true });
  document.addEventListener('shopify:section:load', initCollectionCriteriaFilter);

  } catch(e) { console.error(e); }
})();
})();
